import { makeStyles } from "tss-react/mui";

import { QuizType } from "@/types/quiz";

export const useStyles = makeStyles<{ quizType: QuizType }>()(
  (theme, { quizType }) => ({
    container: {
      display: "flex",
      justifyContent: "center",
      gap: theme.spacing(2),
      padding: theme.spacing(0, 4),
    },
    pillarAdLeft: {
      display: "none",
      [theme.breakpoints.up("xl")]: {
        display: "block",
        position: "sticky",
        top: theme.spacing(4),
        width: 160,
        height: 600,
      },
    },
    pillarAdRight: {
      display: "none",
      [theme.breakpoints.up("lg")]: {
        display: "block",
        position: "sticky",
        top: theme.spacing(4),
        width: 160,
        height: 600,
      },
    },
    content: {
      display: "grid",
      placeItems: "center",
      height: "100%",
      width: "100%",
      maxWidth: "810px !important",
      position: "relative",
      margin: "0 auto",
      paddingTop: theme.spacing(8),
      [theme.breakpoints.down("md")]: {
        paddingTop: theme.spacing(12),
      },
    },
    contentInner: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingBottom: theme.spacing(16),
    },
    inScreenAd: {
      width: "100%",
      marginBottom: theme.spacing(4),
    },
    title: {
      fontSize: "2.38rem",
      textWrap: "balance",
      textAlign: "center",
      margin: 0,
      padding: 0,
      lineHeight: 1,
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(8),
      [theme.breakpoints.down("xxl")]: {
        fontSize: "1.75rem",
      },
      [theme.breakpoints.down("xl")]: {
        fontSize: "1.5rem",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1.38rem",
        marginBottom: theme.spacing(2),
      },
    },
    yourResult: {
      fontSize: "1.63rem",
      fontWeight: 500,
      [theme.breakpoints.down("xl")]: {
        fontSize: "1.38rem",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1.13rem",
      },
    },
    resultValue: {
      fontSize: "1.88rem",
      fontWeight: 700,
      color: theme.palette.secondary.main,
      marginBottom: theme.spacing(7),
      [theme.breakpoints.down("xl")]: {
        fontSize: "1.63rem",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1.38rem",
        marginBottom: theme.spacing(3.5),
      },
    },
    resultDetails: {
      [theme.breakpoints.down("xl")]: {
        display: "flex",
        gap: theme.spacing(6),
        marginBottom: 42,
      },
      [theme.breakpoints.down("lg")]: {
        flexDirection: "column",
        gap: 0,
        marginBottom: 0,
      },
    },
    thumbnailContainer: {
      flex: 1,
      width: "100%",
      marginTop: theme.spacing(5),
    },
    descriptionContainer: {
      flex: 2,
      display: "inline-flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    description: {
      fontSize: quizType === QuizType.QuestionAnswer ? "2rem" : "1.38rem",
      fontWeight: quizType === QuizType.QuestionAnswer ? 700 : 500,
      margin: theme.spacing(5.5, 0),
      [theme.breakpoints.down("xl")]: {
        fontSize: quizType === QuizType.QuestionAnswer ? "1.75rem" : "1.19rem",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: quizType === QuizType.QuestionAnswer ? "1.5rem" : "1rem",
        fontWeight: quizType === QuizType.QuestionAnswer ? 600 : 400,
        margin: theme.spacing(3, 0),
        textAlign: quizType === QuizType.QuestionAnswer ? "center" : "left",
      },
    },
    laptopWatermark: {
      display: "none",
      [theme.breakpoints.down("xl")]: {
        display: "flex",
      },
      [theme.breakpoints.down("lg")]: {
        display: "none",
      },
    },
    timeTaken: {
      fontSize: "1rem",
      color: theme.palette.primary.main,
      fontWeight: 500,
      [theme.breakpoints.down("md")]: {
        textAlign: "center",
      },
    },
    answersTitle: {
      fontSize: "1.5rem",
      color: theme.palette.secondary.main,
      margin: theme.spacing(4, 0),
      [theme.breakpoints.down("xl")]: {
        display: "none",
      },
      [theme.breakpoints.down("lg")]: {
        display: "block",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1rem",
      },
    },
    answersTitleLaptop: {
      display: "none",
      fontSize: "1.25rem",
      color: theme.palette.secondary.main,
      margin: theme.spacing(4, 0),
      [theme.breakpoints.down("xl")]: {
        display: "block",
      },
      [theme.breakpoints.down("lg")]: {
        display: "none",
      },
    },
    leaderboardWrapper: {
      width: "100%",
      marginTop: theme.spacing(5),
      [theme.breakpoints.down("md")]: {
        marginTop: 0,
      },
    },
    answersHeading: {
      width: "100%",
      fontSize: "1.75rem",
      fontWeight: 700,
      textAlign: "center",
      paddingTop: theme.spacing(4),
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(4),
      borderTop: "1px solid #DADADA",
      [theme.breakpoints.down("xl")]: {
        fontSize: "1.5rem",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "1.25rem",
        marginTop: theme.spacing(4),
      },
    },
    answersContainer: {
      marginTop: theme.spacing(4),
    },
    shareContainer: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
    },
    sharePrompt: {
      fontWeight: 500,
    },
    resultThumbnailContainer: {
      position: "relative",
      width: "100%",
      maxWidth: 600,
      maxHeight: "33vh",
      margin: "0 auto",
    },
  })
);
